export default function updateTeammate(state, { payload }) {
  const { index, field, value } = payload;
  state.items[index][field] = value;
}
